module.exports = __webpack_public_path__ + "static/media/image (2).375e2c49.jpg";